import { getAllTeamsGroupId } from 'common/utils/utils';
import { useSelector } from 'react-redux';
import { teamsSelector } from 'state/selectors/teams';
import { uiStateSelector } from 'state/selectors/ui-state';

export const useAllTeams = () => {
  const teams = useSelector(teamsSelector);
  const allTeamsGroupId = getAllTeamsGroupId(teams);
  const { selectedTeamId } = useSelector(uiStateSelector);
  const isAllTeams = allTeamsGroupId && selectedTeamId === allTeamsGroupId;

  return { isAllTeams };
};
